export const LogoMark = ({ className = "h-9 w-9", invert = false }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="10" fill={invert ? "#FFFFFF" : "#05325F"} />
    <path d="M15 11 L31 20 L15 29 Z" fill={invert ? "#05325F" : "#FFFFFF"} />
    <rect x="7.5" y="16.5" width="7" height="7" transform="rotate(45 11 20)" fill="#0085B3" />
  </svg>
);

export const Wordmark = ({ name, invert = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark invert={invert} />
    <span className="text-left leading-none">
      <span className={`block text-base font-bold tracking-tight ${invert ? "text-white" : "text-[#05325F]"}`}>{name}</span>
      <span className={`block text-[11px] uppercase tracking-[0.2em] ${invert ? "text-[#BFD8EE]" : "text-[#4A607A]"}`}>PORTFOLIO</span>
    </span>
  </span>
);
